import React from 'react'
import Card from 'react-bootstrap/Card'
import { Link } from 'react-router-dom'
import { Image } from 'react-bootstrap';

export const QuickLinkCard = ({bg, lightText, customClass, title, imagePath, redirectTo, disabled, disabledText  }) => {
    const titleWords = title && title.split(' ');
    const firstWord = titleWords && titleWords[0];
    const remainingWords = title && titleWords.slice(1).join(' ');

    // CSS for the disabled state and tooltip, included directly in the component
    const disabledStyles = `
        .quicklink-card.disabled {
            opacity: 0.65;
            cursor: not-allowed;
        }
    `;

    // If the card is disabled, we render it without the <Link> element
    // and wrap it in a div with a title for the tooltip.
    if (disabled) {
        return (
            <div title={disabledText}>
                <style>{disabledStyles}</style>
                <Card
                    bg={`${bg ? bg : 'primary'}`}
                    text={`${lightText ? 'light' : ''}`}
                    // The 'disabled' class is added here
                    className={`${customClass ? customClass : ''} quicklink-card border-0 rounded-md disabled`}>
                    <Card.Body className='p-4'>
                        <h4 className='fw-bold d-flex align-items-center justify-content-between'>
                            <span>
                                <span className="d-block">{firstWord}</span> {remainingWords}
                            </span>
                            <Image src='/images/arrow-long-right.svg' className='flex-shrink-0' />
                        </h4>
                        {
                            imagePath &&
                            <figure className="m-0 mt-5 pt-5 text-end">
                                <Image src={`${imagePath}`} className='cardImg' />
                            </figure>
                        }
                        {/* The <Link> is intentionally omitted in the disabled state */}
                    </Card.Body>
                </Card>
            </div>
        );
    }

    return (
        <Card 
            bg={`${bg ? bg : 'primary'}`} 
            text={`${lightText ? 'light' : ''}`} 
            className={`${customClass ? customClass : ''} quicklink-card border-0 rounded-md`}>
            <Card.Body className='p-4'>
                <h4 className='fw-bold d-flex align-items-center justify-content-between'>
                    <span>
                        <span className="d-block">{firstWord}</span> {remainingWords}
                    </span>
                    <Image src='/images/arrow-long-right.svg' className='flex-shrink-0' />
                </h4>
                {
                    imagePath && 
                    <figure className="m-0 mt-5 pt-5 text-end">
                        <Image src={`${imagePath}`} className='cardImg' />
                    </figure>
                }
                <Link to={redirectTo ? redirectTo : '#'} className='stretched-link'></Link>
            </Card.Body>
        </Card>
    )
}
